import Mutations from '../../odata/mutations';

export default { ...new Mutations('medicalDevice'), ...new Mutations('medicalDevices') };
